import { render } from "./pie_pagina.vue?vue&type=template&id=5e621c84"
import script from "./pie_pagina.vue?vue&type=script&lang=js"
export * from "./pie_pagina.vue?vue&type=script&lang=js"

import "./pie_pagina.vue?vue&type=style&index=0&id=5e621c84&lang=css"

import exportComponent from "/Users/mac/Documents/GitHub/cristhianVeAl_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__